export const callLogConstants = {
    CREATE_CALL_LOG_REQUEST: 'CALL_LOG_CREATE_REQUEST',
    CREATE_CALL_LOG_SUCCESS: 'CALL_LOG_CREATE_SUCCESS',
    CREATE_CALL_LOG_FAILURE: 'CALL_LOG_CREATE_FAILURE',
};
